/**
 * 모달 위에 뜨는 전역 레이어(토스트·로딩)의 표식.
 *
 * 이 레이어들은 모달보다 위(Z_INDEX.toast/loading > Z_INDEX.modalHost)에 뜨지만 DOM 상으로는
 * body 직속이라, Radix Dialog 입장에서는 '모달 바깥'이다. 표식이 없으면 토스트 닫기 버튼을
 * 누르는 것만으로 바깥 클릭으로 처리돼 persistent 모달은 흔들리고 일반 모달은 닫혀버린다.
 */
export const GLOBAL_OVERLAY_ATTR = 'data-s-global-overlay';

/** 전역 레이어 루트에 펼쳐 넣는다. */
export const globalOverlayProps = { [GLOBAL_OVERLAY_ATTR]: '' };

/**
 * Radix 의 outside 이벤트(pointerDownOutside/focusOutside/interactOutside)가
 * 전역 레이어에서 비롯됐는지 판별한다. Radix 는 원본 이벤트를 `detail.originalEvent` 에 담는다.
 */
export function isFromGlobalOverlay(event: Event): boolean {
  const detail = (event as CustomEvent<{ originalEvent?: Event }>).detail;
  const target = detail?.originalEvent?.target ?? event.target;
  const element =
    target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
  return !!element?.closest(`[${GLOBAL_OVERLAY_ATTR}]`);
}
